/**
 * Printer setup's "test print" — the receipt that proves a printer answers. Port of web
 * `utils/nativeHooks.js` `printbill` (:35) with its label-printer branch.
 *
 * It never relays: a test print is about THIS device's link to THIS printer.
 */
import { renderTestPrintContent, renderTestPrintLabelContent } from "../content";
import type { Plan, TestPrintInput } from "../types";
import { isEmpty } from "../util";

// No context: a test print reads nothing but the printer it is testing.
export function planTestPrint(input: TestPrintInput): Plan {
  const printer = input.printer;
  if (isEmpty(printer)) return { pieces: [], skipped: [{ reason: "noDefaultPrinter" }] };

  // v1 `!isEmpty(printer?.enableLabelPrinter)` — the string flag being PRESENT, not being "true"
  const label = !isEmpty(printer?.enableLabelPrinter);
  const text = label ? renderTestPrintLabelContent(printer) : renderTestPrintContent(printer);
  return {
    pieces: [{ document: "testPrint", destination: { to: "printer", printer }, copies: 1, source: { kind: "text", text } }],
    skipped: [],
  };
}
